import React from 'react';
import propTypes from 'prop-types';
import { Stepper, Step } from 'react-form-stepper';

export const StepperForm = React.memo(({ activeStep, steps, }) => {
    return (
        <div>
            <Stepper activeStep={activeStep} className='custom-steps' styleConfig={{
                activeBgColor: '#C8D3DE',
                completedBgColor: '#37C2CC',
                size: '2rem',
                completedTextColor: "#ffffff",
                activeTextColor: '#ffffff',
                labelFontSize: '14px'
            }}>
                {!!steps?.length && steps.map(steps =>
                    <Step key={steps?.label} label={<div className='flex flex-col gap-1'>
                        <div>{steps?.label}</div>
                        <span className='text-primary-300 text-xs max-w-250'>{steps?.description}</span>
                    </div>} />)}
            </Stepper>
        </div>
    )
})

StepperForm.propTypes = {
    activeStep: propTypes.number,
    steps: propTypes.array
}

StepperForm.defaultProps = {
    activeStep: 1,
    steps: [
        { step: 1, label: "Source Account & Role" },
        { step: 2, label: "Select Clients" },
    ]
}